module.exports = __webpack_public_path__ + "json/kfzteile-com/manifest.json";